/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { emailIntakeAgentControllerReceive } from "./emailIntakeAgentControllerReceive";

export function emailIntakeAgentService() {
  return { emailIntakeAgentControllerReceive }
}